import React, { Fragment, useState } from 'react';
import { Card, Col, Row, Table, Form, Button, Dropdown, Modal, InputGroup } from 'react-bootstrap';
import { RiSearchLine, RiMore2Fill, RiFileCopyLine, RiPencilLine, RiDeleteBinLine } from 'react-icons/ri';
import '../../../assets/scss/asistente-ia/_asistente-ia.scss';
import NuevoReporte from './NuevoReporte';
import ConfirmacionModal from '../../../components/form-components/confirmacion-modal';
import BusquedaBar from '../../../components/form-components/busqueda-bar';
const AsistenteIA = () => {
  const [informes, setInformes] = useState([
    { nombre: 'Reporte adicional 5', fecha: '25/11/2024', periodicidad: 'Mensual' },
    { nombre: 'Reporte adicional 4', fecha: '24/11/2024', periodicidad: 'Diario' },
    { nombre: 'Reporte adicional 3', fecha: '23/11/2024', periodicidad: 'Mensual' },
    { nombre: 'Reporte adicional 2', fecha: '22/11/2024', periodicidad: 'Semanal' },
    { nombre: 'Reporte adicional 1', fecha: '21/11/2024', periodicidad: 'Mensual' },
    { nombre: 'Análisis de ventas', fecha: '20/11/2024', periodicidad: 'Mensual' },
    { nombre: 'Encuestas ABC', fecha: '20/11/2024', periodicidad: 'Diario' },
    { nombre: 'Análisis de la respuesta del consumidor en la campaña', fecha: '20/11/2024', periodicidad: 'Semanal' },
    { nombre: 'Evaluación de la estrategia de contenidos en la campaña ABC', fecha: '20/11/2024', periodicidad: 'Mensual' },
    { nombre: 'Análisis de la experiencia del usuario', fecha: '20/11/2024', periodicidad: 'Diario' }
  ]);

  const [busqueda, setBusqueda] = useState('');
  const [registrosPorPagina, setRegistrosPorPagina] = useState(5);
  const [paginaActual, setPaginaActual] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [indiceAEliminar, setIndiceAEliminar] = useState(null);
  const [mostrarNuevoReporte, setMostrarNuevoReporte] = useState(false);

  if (mostrarNuevoReporte) {
    return (
      <NuevoReporte
        onVolver={(nuevo) => {
          if (nuevo) setInformes(prev => [nuevo, ...prev]);
          setMostrarNuevoReporte(false);
        }}
      />
    );
  }
  
  


  // Filtrar informes basados en la búsqueda
  const informesFiltrados = informes.filter(informe =>
    informe.nombre.toLowerCase().includes(busqueda.toLowerCase()) ||
    informe.fecha.toLowerCase().includes(busqueda.toLowerCase()) ||
    informe.periodicidad.toLowerCase().includes(busqueda.toLowerCase())
  );

  // Calcular paginación
  const totalPaginas = Math.ceil(informesFiltrados.length / registrosPorPagina);
  const indiceInicial = (paginaActual - 1) * registrosPorPagina;
  const indiceFinal = indiceInicial + registrosPorPagina;
  const informesPaginados = informesFiltrados.slice(indiceInicial, indiceFinal);

  const eliminarInforme = () => {
    const nuevosInformes = [...informes];
    nuevosInformes.splice(indiceAEliminar, 1);
    setInformes(nuevosInformes);
    setShowModal(false);

    // Ajustar paginación si es necesario
    if (paginaActual > 1 && informesPaginados.length === 1) {
      setPaginaActual(paginaActual - 1);
    }
  };

  return (
    <Fragment>
      <Row>
        <Col xl={12}>
          <Card className='card-asistente-ia'>
            <div className="header-section">
              <h3 className='title'>Asistente IA</h3>
              <Button className='new-report-button' onClick={() => setMostrarNuevoReporte(true)}>
                Nuevo reporte
              </Button>
              

            </div>

            <div className="content-section">
              <h5 className='section-subtitle'>
                Registro de informes de análisis
              </h5>
              <p className='section-description'>
                En esta sección podrás visualizar, duplicar, editar, activar o pausar los informes de análisis que el asistente de Inteligencia Artificial te enviará por correo.
              </p>
            </div>

            {/* Barra de búsqueda */}

            <BusquedaBar
              placeHolder="Buscar en registro de informes de análisis"
              value={busqueda}
              onChange={(value) => {
                setBusqueda(value);
                setPaginaActual(1);
              }}
            />

            {/* Tabla de informes */}
            <div className="report-table-container">
              <Table hover responsive className="align-middle text-nowrap mb-0">
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Fecha de creación</th>
                    <th>Periodicidad</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {informesPaginados.map((informe, idx) => (
                    <tr key={idx}>
                      <td>{informe.nombre}</td>
                      <td>{informe.fecha}</td>
                      <td>{informe.periodicidad}</td>
                      <td>
                        <div className="d-flex align-items-center gap-3">
                          <Form.Check
                            type="switch"
                            id={`custom-switch-${idx}`}
                            checked={informe.activo}
                            onChange={() => handleToggleActivo(informes.indexOf(informe))}
                            className="custom-switch"
                          />

                          <Dropdown align="end">
                            <Dropdown.Toggle
                              as="span"
                              variant="link"
                              className="icono-dropdown p-0"
                              aria-expanded="false"
                            >
                              <RiMore2Fill className="text-muted" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="dropdown-menu-end">
                              <Dropdown.Item className="d-flex align-items-center">
                                <RiFileCopyLine className="me-2" /> Duplicar
                              </Dropdown.Item>
                              <Dropdown.Item className="d-flex align-items-center">
                                <RiPencilLine className="me-2" /> Editar
                              </Dropdown.Item>
                              <Dropdown.Item
                                className="d-flex align-items-center text-danger"
                                onClick={() => {
                                  setIndiceAEliminar(informes.indexOf(informe));
                                  setShowModal(true);
                                }}
                              >
                                <RiDeleteBinLine className="me-2" /> Eliminar
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>

            {/* Controles de paginación */}
            <div className="d-flex justify-content-between align-items-center mt-3">
              <div className="d-flex align-items-center">
                <span className="me-2 text-muted">Mostrar</span>
                <Form.Select
                  className="form-select-sm rounded-pill"
                  style={{ width: '80px' }}
                  value={registrosPorPagina}
                  onChange={(e) => {
                    setRegistrosPorPagina(Number(e.target.value));
                    setPaginaActual(1);
                  }}
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="25">25</option>
                </Form.Select>
                <span className="ms-2 text-muted">registros por página</span>
              </div>

              <div className="d-flex align-items-center">
                <span className="me-3 text-muted">
                  Mostrando {indiceInicial + 1} a {Math.min(indiceFinal, informesFiltrados.length)} de {informesFiltrados.length} registros
                </span>

                <nav>
                  <ul className="pagination pagination-sm mb-0">
                    <li className={`page-item ${paginaActual === 1 ? 'disabled' : ''}`}>
                      <button className="page-link rounded-start-pill" onClick={() => setPaginaActual(1)}>Primero</button>
                    </li>
                    <li className={`page-item ${paginaActual === 1 ? 'disabled' : ''}`}>
                      <button className="page-link" onClick={() => setPaginaActual(p => Math.max(1, p - 1))}>&lt;</button>
                    </li>

                    {Array.from({ length: Math.min(5, totalPaginas) }, (_, i) => {
                      let pageNum;
                      if (totalPaginas <= 5) {
                        pageNum = i + 1;
                      } else if (paginaActual <= 3) {
                        pageNum = i + 1;
                      } else if (paginaActual >= totalPaginas - 2) {
                        pageNum = totalPaginas - 4 + i;
                      } else {
                        pageNum = paginaActual - 2 + i;
                      }

                      return (
                        <li key={pageNum} className={`page-item ${paginaActual === pageNum ? 'active' : ''}`}>
                          <button className="page-link" onClick={() => setPaginaActual(pageNum)}>{pageNum}</button>
                        </li>
                      );
                    })}

                    <li className={`page-item ${paginaActual === totalPaginas ? 'disabled' : ''}`}>
                      <button className="page-link" onClick={() => setPaginaActual(p => Math.min(totalPaginas, p + 1))}>&gt;</button>
                    </li>
                    <li className={`page-item ${paginaActual === totalPaginas ? 'disabled' : ''}`}>
                      <button className="page-link rounded-end-pill" onClick={() => setPaginaActual(totalPaginas)}>Último</button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>

            {/* Modal de confirmación */}
            <ConfirmacionModal
            show={showModal}
            onHide={() => setShowModal(false)}
            onConfirm={eliminarInforme}
            title=" ¿Te gustaría eliminar permanentemente este registro de análisis?" 
            message="Una vez eliminado, dejará de ser accesible."
            confirmButtonText="Eliminar"
            cancelButtonText="Cancelar"
            />
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};

export default AsistenteIA;
